import { render, staticRenderFns } from "./questionsCallForm.vue?vue&type=template&id=30ed139c&scoped=true&"
import script from "./questionsCallForm.vue?vue&type=script&lang=js&"
export * from "./questionsCallForm.vue?vue&type=script&lang=js&"
import style0 from "./questionsCallForm.vue?vue&type=style&index=0&id=30ed139c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ed139c",
  null
  
)

export default component.exports